<template>
  <v-dialog
    v-model="showDialogVerifySmsToken"
    content-class="dialogStyle"
    max-width="450"
    persistent
  >
    <v-card class="grey darken-4" style="border-radius: 8px;">
      <v-toolbar
        class="grey darken-4 elevation-0"
        height="64"
      >
        <v-toolbar-title
          v-if="showDialogVerifySmsTokenStore.typeVerification"
          class="d-flex align-center"
          style="white-space: normal;"
        >
          {{ $t(`verifySmsToken.${
            showDialogVerifySmsTokenStore.typeVerification
          }`) }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialogVerifySmsToken">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="px-4 pb-0">
        <span v-html="$t('verifySmsToken.insertTokenHere')"></span>

        <div class="my-2 mb-6">
          <div class="d-flex justify-space-between">
            <v-scale-transition>
              <span
                style="transition: all 0.1s; color: #e84343;"
                :style="{ opacity: errorToken ? 1 : 0 }"
              >
                {{ $t("verifySmsToken.invalidToken") }}
              </span>
            </v-scale-transition>
            <v-btn
              color="primary"
              text
              small
              :disabled="loadingBtn"
              @click="clearOtp"
            >
              {{ $t("toClean")}}
            </v-btn>
          </div>

          <div ref="otpWrapper" class="otp-wrapper py-2">
            <v-otp-input
              class="justify-space-between"
              :class="{ 
                'disable-submit-otp': loadingBtn,
                'mobileStyle': $vuetify.breakpoint.width < 380,
              }"
              ref="otpInput"
              input-classes="otp-input"
              separator=""
              :num-inputs="6"
              :should-auto-focus="true"
              style="width: 100%;"
              @on-change="onChangeToken"
              @on-complete="onCompleteToken"
            />
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="px-4 pb-6">
        <v-btn
          color="primary"
          :loading="loadingBtn"
          :disabled="loadingBtn || countdownsResend.timer !== 0"
          block
          large
          @click="handleSendToken"
        >
          {{
            countdownsResend.timer === 0
              ? $t("verifySmsToken.resendToken")
              : $t("verifySmsToken.resendTokenTimer", {
                  seconds: countdownsResend.timer,
                })
          }}
        </v-btn>
      </v-card-actions>

      <div
        v-if="
          showDialogVerifySmsTokenStore.typeVerification ==
          'twoStepsAuthentication'
        "
        class="mx-4 pb-6"
        style="font-size: 12px;"
      >
        {{ $t("verifySmsToken.deactivateTwoStepsAuthentication") }}
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
const COUNTER_MAX = 60;

export default {
  name: "DialogVerifySmsToken",

  data: () => ({
    showDialogVerifySmsToken: false,
    loadingBtn: false,
    currentOtpToken: "",
    errorToken: false,
    countdownsResend: {
      timer: COUNTER_MAX,
      intervalId: 0,
    },
  }),

  mounted() {
    this.closeDialogVerifySmsToken();
  },

  watch: {
    showDialogVerifySmsTokenStore(dialogState) {
      if (dialogState.status === true) {
        this.showDialogVerifySmsToken = true;

        // Query adicionada pelo fluxo de ativação de Verificação de duas etapas
        // com Telefone não verificado
        this.$handleURLState("typeVerification", "delete");

        if (dialogState.login) {
          // Fluxo de Verificação de duas etapas no Login
          if (this.countdownsResend.timer === COUNTER_MAX)
            this.initializeOrResetTimerCounter();

          // Focar o primeiro campo do OTP
          this.$nextTick(() => {
            this.focusFirstOtpNumber();
          });
        } else {
          // Fluxo de Verificação de telefone ou Verificação de duas etapas
          this.sendSmsToken();
        }
      } else if (!this.showDialogVerifySmsToken) {
        this.closeDialogVerifySmsToken();
      }
    },
    currentOtpToken(val) {
      if (val.length < 6) return;

      for (const { $el } of this.$refs["otpInput"].$children) {
        const inputWrapper = $el;
        const input = inputWrapper.querySelector("input");

        input.blur();
      }
    },
    "$route.name"() {
      if (this.$refs.otpInput) this.clearOtp();

      this.currentOtpToken = "";
    },
    "countdownsResend.timer"(timer) {
      if (timer <= 0) clearInterval(this.countdownsResend.intervalId);
    }
  },

  computed: {
    showDialogVerifySmsTokenStore() {
      const dialogState = this.$store.getters.getDialogVerifySmsToken;

      return dialogState;
    },
    disableResendOtp() {
      return this.countdownsResend.timer !== 0;
    },
  },

  methods: {
    closeDialogVerifySmsToken(trigger = "") {
      this.showDialogVerifySmsToken = false;
      this.currentOtpToken = "";
      this.clearOtp();
      if (this.showDialogVerifySmsTokenStore.login) this.resetOtpTimers();

      if (this.showDialogVerifySmsTokenStore.status) {
        this.$store.commit("setDialogVerifySmsToken",
          {
            status: false,
            typeVerification: "",
            ...(trigger ?
              {
                trigger,
              } : {}
            ),
          },
        );
      }
    },
    focusFirstOtpNumber() {
      if (this.$refs.otpInput && this.$refs.otpInput.$children) {
        setTimeout(() => {
          const firstDiv = this.$refs.otpInput.$children[0].$el;
          const firstInput = firstDiv.querySelector("input");
          firstInput.focus();
        }, 10);
      }
    },
    onCompleteToken(val) {
      this.currentOtpToken = val;

      this.handleVerifyToken(
        this.showDialogVerifySmsTokenStore.login
          ? "login"
          : "verifyPhoneOrTwoStepsAuth"
      );
    },
    onChangeToken() {
      this.setInputOrErrorToken(false);
    },
    clearOtp() {
      this.$refs.otpInput && this.$refs.otpInput.clearInput();
    },
    resetOtpTimers(sendSmsTokenError) {
      this.countdownsResend.timer = sendSmsTokenError ? 0 : COUNTER_MAX;
      clearInterval(this.countdownsResend.intervalId);
      this.countdownsResend.intervalId = 0;
    },
    setInputOrErrorToken(bool) {
      const method = bool ? "add" : "remove";
      this.errorToken = bool;

      for (const { $el } of this.$refs["otpInput"].$children) {
        const inputWrapper = $el;
        const input = inputWrapper.querySelector("input");
        input.classList[method]("otpInputError");
      }
    },
    handleSendToken() {
      this.loadingBtn = true;

      // Limpar input e Focar o primeiro campo do OTP
      this.clearOtp();
      this.focusFirstOtpNumber();

      // Fluxo de login
      if (this.showDialogVerifySmsTokenStore.login) {
        // Fluxo de Reenvio de token no Login
        this.doLogin("resendToken");
      } else {
        // Fluxo de Verificação de telefone ou Verificação de duas etapas
        this.sendSmsToken();
      }
    },
    // Verificação de celular ou Ativação da Autenticação de duas etapas
    sendSmsToken() {
      // Só será feita requisição de envio de Token para o usuário caso
      // o timer estiver em 0 ou 60, dentro desse range não será feita
      this.initializeOrResetTimerCounter();

      if (
        this.countdownsResend.timer > 0
        && this.countdownsResend.timer < COUNTER_MAX
      ) return;

      this.$axios
        .get("player/profile/sendSmsToken")
        .then((resp) => {
          this.$store.commit("setNotification", {
            msg: resp.data.messages,
            color: "green",
          });
        })
        .catch((err) => {
          // Em caso de erro no Envio ou Reenvio do token,
          // habilitar botão de Reenvio
          localStorage.setItem("resendVerifySmsTokenCounter", Date.now());
          this.resetOtpTimers(true);

          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.loadingBtn = false;
          this.clearOtp();
          this.focusFirstOtpNumber();
          this.currentOtpToken = "";
        });
    },
    handleVerifyToken(type) {
      if (this.currentOtpToken.length !== 6) return;

      this.loadingBtn = true;

      if (type === "login") {
        this.doLogin();
      } else {
        this.verifySmsToken();
      }
    },
    doLogin(resendToken) {
      if (resendToken) this.initializeOrResetTimerCounter();

      this.$login(
        this.showDialogVerifySmsTokenStore.login,
        this.showDialogVerifySmsTokenStore.password,
        false,
        resendToken ? "" : this.currentOtpToken,
      ).then((resp) => {
        this.$store.commit("setNotification", {
          msg: resp.message,
          color: "green",
        });

        // Caso não tenha essa flag que é enviada via "resolve()" do "tokenSent"
        // significa que é statusCode 200 de Logado, sendo assim,
        // o Timestamp armazenado no localStorage será removido e a Dialog será fechada
        if (!resp.tokenTwoStepsAuth) {
          localStorage.removeItem("resendVerifySmsTokenCounter");

          this.closeDialogVerifySmsToken();
        }

        if (
          this.$route.path.includes("casino/lobby")
          && resp.statusCode != 202
        ) {
          this.$router.push(this.urlRedirect ? this.urlRedirect : "/");
        } else if (resp.statusCode != 202) {
          this.$router.push(this.urlRedirect ? this.urlRedirect : "/");
        }
      }).catch((err) => {
        const errorData = err.response.data.messages;

        // Em caso de erro no Reenvio do token, habilitar botão de Reenvio
        if (errorData.dados.error_sending_token) {
          localStorage.setItem("resendVerifySmsTokenCounter", Date.now());
          this.resetOtpTimers(true);
        }

        // Caso seja erro de token na API por erro de token inválido por exemplo
        // sinalizar erro para usuário
        if (
          this.currentOtpToken.length === 6
          && !errorData.dados.error_sending_token
        ) {
          this.clearOtp();
          this.setInputOrErrorToken(true);
        }

        this.$store.commit("setNotification", {
          msg: errorData.messages,
          color: "warning",
        });
      })
      .finally(() => {
        this.loadingBtn = false;
        this.clearOtp();
        this.focusFirstOtpNumber();
        this.currentOtpToken = "";
      });
    },
    verifySmsToken() {
      const bodyTypeVerification =
        this.showDialogVerifySmsTokenStore.bothVerification
        ? "both"
        : this.showDialogVerifySmsTokenStore.removeTwoStepsAuth
        ? "removeTwoStepsAuth"
        : this.showDialogVerifySmsTokenStore.typeVerification;

      this.$axios
        .post(
          "player/profile/verifySmsToken",
          this.$formdata({
            token: this.currentOtpToken,
            verification_type: bodyTypeVerification,
          })
        )
        .then((resp) => {
          // Resetando timers
          localStorage.setItem("resendVerifySmsTokenCounter", Date.now());
          this.resetOtpTimers(false);

          // Remover alert caso o usuário já tenha 2FA ativo
          if (this.showDialogVerifySmsTokenStore.typeVerification == "twoStepsAuthentication")
            localStorage.setItem("alertActivateTwoStepsAuthentication", true);

          // Fechar dialog triggando endpoints de views pais como
          // página Verificar e Perfil > Segurança
          this.closeDialogVerifySmsToken(
            this.showDialogVerifySmsTokenStore.typeVerification
          );

          this.$store.commit("setNotification", {
            msg: resp.data.messages,
            color: "green",
          });
        })
        .catch((err) => {
          this.clearOtp();
          this.setInputOrErrorToken(true);

          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.loadingBtn = false;
          this.currentOtpToken = "";
        });
    },
    initializeOrResetTimerCounter(firstInitialize) {
      const storageResendVerifySmsTokenCounter = localStorage.getItem(
        "resendVerifySmsTokenCounter"
      );

      if (
        storageResendVerifySmsTokenCounter
        && storageResendVerifySmsTokenCounter > Date.now()
      ) {
        // Buscando milisegundos restantes pré-armazenados no localStorage e
        // transformando em segundos
        const localStorageTimer =
          Math.floor((storageResendVerifySmsTokenCounter - Date.now()) / 1000);

        this.countdownsResend.timer = localStorageTimer;

        if (this.countdownsResend.intervalId === 0 || firstInitialize) {
          this.countdownsResend.intervalId =
            setInterval(this.intervalIdFunctionCounter, 1000);
        }
      } else {
        // Fluxo quando não há timer iniciado anteriormente ou o timestamp
        // armazenado no localStorage esteja expirado, sendo assim,
        // Será reiniciado o fluxo com um timestamp novo armazenado
        localStorage.setItem("resendVerifySmsTokenCounter", Date.now() + 60000);
        this.initializeOrResetTimerCounter("firstInitialize");
      }
    },
    intervalIdFunctionCounter() {
      if (this.countdownsResend.timer == 1) {
        this.countdownsResend.timer = 0;
        clearInterval(this.countdownsResend.intervalId);
        localStorage.removeItem("resendVerifySmsTokenCounter");
      } else {
        this.countdownsResend.timer -= 1;
      }
    },
  },
};
</script>

<style>
.dialogStyle {
  margin: 12px;
}

.otp-wrapper {
  display: flex;
  justify-content: space-between;
}

.otp-input:first-child {
  margin-left: 0;
}

.otp-input:last-child {
  margin-right: 0;
}

.otp-input {
  width: 50px;
  height: 55px;
  padding: 5px;
  margin: 0 8px;
  font-size: 20px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  color: white;
  text-align: center;
}

.mobileStyle .otp-input {
  width: 40px;
  height: 55px;
}

.otpInputError {
  border-color: #e84343 !important;
}

.otpWrapperError {
  border: 1px solid #e84343;
}

.otp-small {
  width: 30px;
  height: 30px;
  padding: 5px;
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.disable-submit-otp {
  pointer-events: none;
  color: grey;
}
</style>